<template>
  <div class="myanli" @click="handleClickBody">
    <myHeader />
    <div class="bg">
      <div>
<!--        <h1 class="wow fadeInUp enProductTitle">Case Study</h1>-->
      </div>
      <div class="app">
        <div class="case_wrap" style="max-width: 1210px;margin: 0 auto;">
<!--          <div class="case_top">-->
<!--            <div class="nav_level">-->
<!--              <div class="switch_list wow fadeInUp" ref="switch_list">-->
<!--                <div class="switch_list_li" v-for="(item, index) in case_nav_list">-->
<!--                  <span   :key="index"  v-text="item.title"    @click="handleClickNav(item, index, item.type)"  :class="{ active: currentTabIndex === index }"  ></span>-->
<!--                  <div class="tag_group" v-if="case_nav_list.length > 0">-->
<!--                    <ul>-->
<!--                      <li v-for="item in case_nav_list[currentTabIndex].child">-->
<!--                        <div class="tag_group_name"  :class="activeType2.indexOf(item.id) > -1 ? 'active' : ''"  @click="handleClickType2(item)">-->
<!--                          {{ item.title }}-->
<!--                        </div>-->
<!--                        <div class="tag_group_list">-->
<!--                          <div v-for="child in item.child">-->
<!--                            <span class="tag_class"  :class="activeType3.indexOf(child.id) > -1 ? 'active' : ''"  @click="handleClickChildNav(child)" v-text="child.title" ></span>-->
<!--                          </div>-->
<!--                        </div>-->
<!--                      </li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div-->
<!--                class="underline"-->
<!--                :style="{-->
<!--                  width: underlineWidth + 'px',-->
<!--                  left: underlineLeft + 'px',-->
<!--                }"-->
<!--              ></div>-->
<!--            </div>-->

<!--          </div>-->

          <div class="case_navigation">
            <h1 class="wow fadeInUp ProductTitle ta-l">Case Study</h1>
            <ul class="wow fadeInUp">
              <li v-for="item in case_nav_list">
                <div class="case_navigation_top" @click.stop="handleClickCaseNav(item)">
                  <span>{{item.title}}</span> <i class="el-icon-arrow-down"></i>
                </div>
                <div class="case_navigation_bottom" v-if="item.open" @click.stop>
                  <span class="case_navigation_span" v-for="child in item.child"  :class="activeType2.indexOf(child.id) > -1 ? 'active' : ''"  @click="handleClickChildCaseNav(item,child)">
                    <span class="border_icon">
                          <i class="el-icon-check"></i>
                    </span>
                    <span class="case_navigation_text" v-text="child.title"></span>
                  </span>
                </div>
              </li>
              <div class="reset" @click="handleClickReset">reset</div>
            </ul>
          </div>

          <div class="case_bottom">
            <div class="case-list2">
              <div
                v-for="(caseItem, index) in cases"
                :key="index"
                class="case-item2 wow fadeInUp"
                @click="pageTransition(caseItem)"
              >
                <img :src="caseItem.cover" alt="案例图片" />
                <div class="case-info">
                  <h2>{{ caseItem.title }}</h2>
                  <p>{{ caseItem.subTitle }}</p>
                  <p>{{ caseItem.name }}</p>
                </div>
              </div>
            </div>
            <button
              v-if="!showAll"
              @click="showAllCases"
              class="butt"
            >
              VIEW ALL CASES
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 视频详情组件 -->
    <div
      class="video_detail"
      v-if="VideoDetailsIsShow"
      @click.self="closeDetail"
    >
      <button class="video_close" @click="closeDetail">&times;</button>
      <div class="video_detail_content">
        <div class="content_top">
          <div class="content_top_left">
            <video :src="videoDetailMsg.link" autoplay controls muted></video>
          </div>
          <div class="content_top_right">
            <div class="content_top_r_item" v-for="videoItem in cases">
              <div class="item_img">
                <img :src="videoItem.cover" alt="" />
                <div class="video_play" @click="pageTransition(videoItem)">
                  <div class="video_play_icon"></div>
                </div>
              </div>
              <p class="ellipsis-text">{{ videoItem.title }}</p>
            </div>
          </div>
        </div>
        <div class="content_bottom">
          <div class="content_bottom_text">
            <h2>{{ videoDetailMsg.title }}</h2>
            <p>{{ videoDetailMsg.describe }}</p>
          </div>
        </div>
      </div>
    </div>
    <my-footer />
    <BackToTop />
  </div>
</template>

<script>
import myHeader from "@/components/en_pc/myHeader.vue";
import MyFooter from "@/components/en_pc/myFooter.vue";
import BackToTop from "@/components/en_pc/BackToTop";
import { getCaseClassificationList, getCaseList } from "@/api/api";

export default {
  components: { myHeader, MyFooter, BackToTop },
  data() {
    return {
      list: [],
      VideoDetailsIsShow: false,
      videoDetailMsg: {},
      videoList: {},
      // 修改：使用对象存储各一级菜单对应的二级菜单选中状态
      childSelection: {},
      topNav: "展演案例",
      selectedCategory: "舞台演出",
      activeIndex: 0,
      dotMoveWidth: 140,
      isScrollDisabled: false,
      cases: [],
      case_nav_list: [  ],
      allData: [],
      expand_retract: true,
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      currentChildIndex: 0,
      boxHeight: 0,
      showAll: false,
      childrenList: [],
      type: "",
      tag_groups: [],
      activeTags:[],
      activeType2:[],
      activeType3:[],
      pageNum:1
    };
  },
  computed: {
  },
  mounted() {
    this.$nextTick(() => {

      // this.setupSpanResizeObservers();
      // window.addEventListener("resize", this.updateUnderlinePosition);
      // this.$refs.nav_child_content.style.height = "auto";
      window.addEventListener("popstate", this.handlePopState);
      this.boxHeight = 86;
    });
  },
  created() {
    this.getCaseClassificationLists();
  },
  beforeDestroy() {
    document.body.style.overflow =  "auto";
    // window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener("popstate", this.handlePopState);
  },
  methods: {
    // 获取指定一级菜单对应的二级菜单选中索引数组
    getSelectedChildIndexes(tabIndex) {
      if (!this.childSelection[tabIndex]) {
        this.childSelection[tabIndex] = [];
      }
      return this.childSelection[tabIndex];
    },

    // 点击一级菜单
    handleClickNav(item, index, type) {
      this.currentTabIndex = index;
      this.currentChildIndex = 0;
      this.updateUnderlinePosition();
      this.activeType2 = [];
      this.activeType3 = [];
      this.handleClickSearch();
    },

    // 点击第二级菜单
    handleClickType2(item) {
      if (this.activeType2.indexOf(item.id) > -1) {
        this.activeType2.splice(this.activeType2.indexOf(item.id), 1);
      } else {
        this.activeType2.push(item.id);
      }
      this.handleClickSearch();
    },
    // 点击第三级菜单
    handleClickChildNav(child) {
      if (this.activeType3.indexOf(child.id) > -1) {
        this.activeType3.splice(this.activeType3.indexOf(child.id), 1);
      } else {
        this.activeType3.push(child.id);
      }
      this.handleClickSearch();
    },


    handleClickBody(){
      this.case_nav_list.forEach(item=>{
        this.$set(item,'open',false)
      })
    },
    handleClickCaseNav(item){
      this.$set(item,'open',!item.open)
    },

    handleClickChildCaseNav(item,child){
      if (this.activeType2.indexOf(child.id) > -1) {
        this.activeType2.splice(this.activeType2.indexOf(child.id), 1);
      } else {
        this.activeType2.push(child.id);
      }
      this.handleClickSearch();
    },
    // 重置
    handleClickReset(){
      this.pageNum = 1
      this.activeType2 = []
      this.handleClickSearch();
    },

    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("div.switch_list_li")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },

    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("div.switch_list_li");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
    handleClickSearch(){
      this.pageNum = 1
      this.cases = []
      this.showAll = false
      this.getCaseList()
    },

    showAllCases() {
      this.pageNum = this.pageNum + 1
      this.getCaseList()
    },

    goViewDetails(videoUrl) {
      window.open(videoUrl);
    },

    getCaseClassificationLists() {
      getCaseClassificationList().then((res) => {
        if(res.code == 200){
          this.case_nav_list = res.data
        }
        this.handleClickSearch()
      });
    },

    getCaseList(){
      let postData = {
        page: this.pageNum,
        limit:9,
        type2: this.activeType2.join(","),
      };
      getCaseList(postData).then((res) => {
        let {data} = res
        if(data.length < 9){
          this.showAll = true
        }
        this.cases =  this.cases.concat(data);
      });
    },

    pageTransition(item) {
      if (item && item.link) {
        this.videoDetailMsg = item;
        this.VideoDetailsIsShow = true;
        this.disableScroll();
      } else {
        console.error("item is undefined or does not have a link property");
      }
    },

    closeDetail() {
      this.VideoDetailsIsShow = false;
      this.enableScroll();
    },

    disableScroll() {
      if (!this.isScrollDisabled) {
        this.originalOverflow = document.body.style.overflow;
        document.body.style.overflow = "hidden";
        this.isScrollDisabled = true;
      }
    },

    enableScroll() {
      if (this.isScrollDisabled) {
        document.body.style.overflow = this.originalOverflow || "auto";
        this.isScrollDisabled = false;
      }
    },

    handlePopState() {
      if (this.VideoDetailsIsShow) {
        this.VideoDetailsIsShow = false;
        this.enableScroll();
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/styles/en_pc/wsc.scss";
</style>
